import React from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Route } from "react-router-dom";
import NavBar from "./Components/navBar.jsx";
import Home from "./Components/home.jsx";
import Overview from "./Components/overview.jsx";
import Profile from "./Components/profile.jsx";
import Intro from "./Components/intro.jsx";
import Contact from "./Components/contact.jsx";
import Logo from "./Components/logo.jsx";
import Journal from "./Components/journal.jsx";
import History from "./Components/history.jsx";
import Communication from "./Components/communication";
import Research from "./Components/research";
import Youtube from "./Images/youtube.png";
import Facebook from "./Images/fb.jpg";

function App() {
  return (
    <BrowserRouter>
      <NavBar />
      <div>
        <Route path="/" component={Home} exact />
        <Route path="/profile" component={Profile} exact />
        <Route path="/intro" component={Intro} exact />
        <Route path="/overview" component={Overview} exact />
        <Route path="/contact" component={Contact} exact />
        <Route path="/logo" component={Logo} exact />
        <Route path="/history" component={History} exact />
        <Route path="/communication" component={Communication} exact />
        <Route path="/research" component={Research} exact />
        <Route path="/journal" component={Journal} exact />
      </div>
      <hr />
      <div className="text-center media-handles">
        <a
          href="https://www.youtube.com/channel/UCbQGMqoOAkbyPYT6QTxe7bg/videos"
          target="blank"
        >
          <img
            className="foot1 img-fluid"
            src={Youtube}
            alt="Youtube"
            width="30"
            height="30"
          />
        </a>
        <a href="https://web.facebook.com/ProfGadagbui" target="blank">
          <img
            className="foot1 img-fluid"
            src={Facebook}
            alt="Youtube"
            width="30"
            height="30"
          />
        </a>
      </div>
      <hr />

      <footer>
        <div className="text-center">
          <h6>Contact Professor Gadagbui on</h6>
          <ul>
            <div>+233 (0)24-255 2348</div>
            <div>+233 (0)59-260 5693</div>
            <div>+233 (0)20-973 1933</div>
          </ul>
        </div>
        <hr />
        <p className="footer">
          &copy;2022 New-Age Academy of Education and Research
        </p>
      </footer>
    </BrowserRouter>
  );
}

export default App;
